module.exports = "<div ng-if=\"vm.showProgressBar()\" class=\"radial-progress-bar__overlay\">\n  {{vm.stepProgress}}%\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/radialProgressBar/radialProgressBar.html
// module id = 544
// module chunks = 1